import { cn } from "@/lib/utils";

interface AnserMarkProps {
  /** 18 px inline (buttons, kickers) or 46 px block (brand, panel header). */
  size?: 18 | 46;
  /** The brand block's soft glow behind the mark. */
  glow?: boolean;
  className?: string;
}

const SIZE_CLASSES: Record<NonNullable<AnserMarkProps["size"]>, string> = {
  18: "h-[18px] w-[18px]",
  46: "h-[46px] w-[46px]",
};

/**
 * Anser's brand mark: the gradient glyph from the design bundle
 * (`/brand/anser-mark.webp`, Jonas Larsson, Oct 2026). Decorative; the
 * surrounding control carries the accessible name. Distinct from `AiMark`,
 * which labels AI-generated content.
 */
export function AnserMark({ size = 18, glow = false, className }: AnserMarkProps) {
  return (
    <span
      aria-hidden="true"
      data-testid="anser-mark"
      className={cn(
        "relative inline-flex shrink-0 items-center justify-center",
        SIZE_CLASSES[size],
        className,
      )}
    >
      {glow ? (
        <span
          aria-hidden="true"
          className="absolute inset-[-4px_-2px] rounded-g-pill bg-g-primary-muted opacity-[var(--g-glow-opacity,0.6)] blur-[7px]"
        />
      ) : null}
      <img
        src="/brand/anser-mark.webp"
        alt=""
        draggable={false}
        className="relative h-full w-full object-contain"
      />
    </span>
  );
}
